import type { AnnotationStoreT } from '../../labelling/types';
import type { AnnotationMetadataRecord } from '../types/annotation';
export function collectIdsByLabel(annotationMetadata: AnnotationMetadataRecord, labelId: string): string[] {
  const ids = new Set<string>();
  for (const [id, metadata] of annotationMetadata.entries()) {
    if (metadata.labelId === labelId) {
      ids.add(id);
    }
  }
  return Array.from(ids);
}
export function collectIdsByLabelFromMLStore(mlAnnotationFrames: Map<number, AnnotationStoreT>, labelId: string): string[] {
  const ids = new Set<string>();
  for (const [, annotationStore] of mlAnnotationFrames) {
    for (const [id, annotation] of Object.entries(annotationStore)) {
      if (annotation.annotationLabel.title === labelId) {
        ids.add(id);
      }
    }
  }
  return Array.from(ids);
}
export function collectAllAnnotationIds(annotationMetadata: AnnotationMetadataRecord): string[] {
  return Array.from(annotationMetadata.keys());
}
export function collectIdsByLabelTitles(annotationMetadata: AnnotationMetadataRecord, labelTitles: string[]): string[] {
  const ids = new Set<string>();
  for (const [id, metadata] of annotationMetadata.entries()) {
    if (labelTitles.includes(metadata.labelId)) {
      ids.add(id);
    }
  }
  return Array.from(ids);
}
export function collectIdsByLabelTitlesFromMLStore(mlAnnotationFrames: Map<number, AnnotationStoreT>, labelTitles: string[]): string[] {
  const ids = new Set<string>();
  for (const [, annotationStore] of mlAnnotationFrames) {
    for (const [id, annotation] of Object.entries(annotationStore)) {
      if (labelTitles.includes(annotation.annotationLabel.title)) {
        ids.add(id);
      }
    }
  }
  return Array.from(ids);
}